import React, { ReactNode } from "react";
import './TitleReadOnly.scss';

export const TitleReadOnly = ({
  children
}: {
  children: ReactNode
}) => (<h4 className="title">{children}</h4>);